export default __webpack_public_path__ + "static/media/Scholar's Bracelet of the Waning Moon.9174a650.jpg";